import React, { useState } from "react";
import "./HeroDataSection.css";
import { useEffect } from "react";
import { FaCar, FaBicycle, FaMotorcycle } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import TimeInput from "../HeroDataSection/TimeInput";
const HeroDataSection = () => {
  
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState("car");
  const [tab, setTab] = useState("booking");
  const [trip, setTrip] = useState("oneway");
  const [rentalType, setRentalType] = useState("driver");
  const [airportType, setAirportType] = useState("pickup");
const [date, setDate] = useState(new Date());
  const [time, setTime] = useState("01:00 AM");
  const [bookings, setBookings] = useState([]);
  const [formData, setFormData] = useState({
    from: "",
    to: "",
    pickup: "",
    drop: "",
    airport: "",
    address: "",
    date: new Date(),
    returnDate: null,
    time: "01:00 AM",
    returnTime: "01:00 AM",
  });
   useEffect(() => {
     if (vehicle === "car") {
       setTab("booking");
     } else {
       setTab("rental");
     }
   }, [vehicle]);
const handleBooking = () => {
  let isValid = true;
  let pickup = "";
  let drop = "";

 
  if (tab === "booking") {
    if (trip === "airport") {
      if (airportType === "pickup") {
        if (!formData.airport || !formData.address) isValid = false;
      } else {
        if (!formData.from || !formData.airport) isValid = false;
      }
    } else {
      if (!formData.from || !formData.to) isValid = false;
    }
  }


  if (tab === "rental") {
    if (vehicle === "car") {
      if (!formData.from || !formData.address) {
        isValid = false;
      }
    }
  }

  if (!formData.date || !formData.time) {
    isValid = false;
  }


  if (!isValid) {
    alert("Please fill all required fields");
    return;
  }

  if (tab === "booking") {
    if (trip === "airport") {
      if (airportType === "pickup") {
        pickup = formData.airport;
        drop = formData.address;
      } else {
        pickup = formData.from;
        drop = formData.airport;
      }
    } else {
      pickup = formData.from;
      drop = formData.to;
    }
  }

  
  if (tab === "rental") {
    pickup = formData.from;
    drop = formData.address;
  }

  
  const newBooking = {
    vehicle,
    tab,
    trip,
    rentalType,
    pickup,
    drop,
    date: formData.date.toISOString(),
    time: formData.time,
  };

  localStorage.setItem("tripData", JSON.stringify(newBooking));

 
  if (vehicle === "car") {
       if (tab === "rental") {
         if (rentalType === "self") {
           navigate("/self-drive-rental", { state: newBooking });
         } else if (rentalType === "driver") {
           navigate("/with-driver-rental", { state: newBooking });
         } else if (rentalType === "wedding") {
           navigate("/vintage-rental", { state: newBooking });
         }
       } else {
         navigate("/car-booking", { state: newBooking });
       }
  }
   if (vehicle === "bike") {
     navigate("/bike-rental-page", { state: newBooking });
   }

   if (vehicle === "bicycle") {
     navigate("/bicycle-rental-page", { state: newBooking });
   }
};
  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  return (
    <div className="booking-wrapper">
      {/* VEHICLE ICONS */}
      <div className="vehicle-icons">
        <FaCar
          className={`icon ${vehicle === "car" ? "active" : ""}`}
          onClick={() => setVehicle("car")}
        />

        <FaMotorcycle
          className={`icon ${vehicle === "bike" ? "active" : ""}`}
          onClick={() => setVehicle("bike")}
        />

        <FaBicycle
          className={`icon ${vehicle === "bicycle" ? "active" : ""}`}
          onClick={() => setVehicle("bicycle")}
        />
      </div>

  
      <div className="booking-tabs">
        {(vehicle === "car"
          ? ["booking", "rental"]
          : vehicle === "bike"
            ? ["rental", "booking"]
            : ["rental"]
        ) 
          .map((item) => {
            const isComingSoon = vehicle === "bike" && item === "booking";

            return (
              <div className="tab-item" key={item}>
          
                {isComingSoon && (
                  <span className="coming-soon">Coming Soon</span>
                )}

                <span
                  className={tab === item ? "active" : ""}
                  onClick={() => {
                    if (!isComingSoon) setTab(item); // 🚫 disable click
                  }}
                  style={{
                    cursor: isComingSoon ? "not-allowed" : "pointer",
                    opacity: isComingSoon ? 0.6 : 1,
                  }}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </span>
              </div>
            );
          })}
      </div>
      {/* ================= CAR BOOKING ================= */}

      {vehicle === "car" && tab === "booking" && (
        <>
          <div className="radio-section">
            <label>
              <input
                type="radio"
                name="trip"
                checked={trip === "oneway"}
                onChange={() => setTrip("oneway")}
              />
              Outstation One-way
            </label>

            <label>
              <input
                type="radio"
                name="trip"
                checked={trip === "roundtrip"}
                onChange={() => setTrip("roundtrip")}
              />
              Outstation Round-Trip
            </label>

            <label>
              <input
                type="radio"
                name="trip"
                checked={trip === "airport"}
                onChange={() => setTrip("airport")}
              />
              Airport Transfer
            </label>

            <label>
              <input
                type="radio"
                name="trip"
                checked={trip === "local"}
                onChange={() => setTrip("local")}
              />
              Local/Hourly
            </label>
          </div>

          <div className="form-grid">
            {trip === "oneway" && (
              <>
                <div className="input">
                  <label>From</label>
                  <input
                    type="text"
                    placeholder="Enter pickup location"
                    value={formData.from}
                    onChange={(e) => handleChange("from", e.target.value)}
                  />
                </div>

                <div className="input">
                  <label>To</label>
                  <input
                    type="text"
                    placeholder="Enter destination"
                    value={formData.to}
                    onChange={(e) => handleChange("to", e.target.value)}
                  />
                </div>

                <div className="input">
                  <label>Date</label>
                  <DatePicker
                    selected={formData.date}
                    onChange={(d) => handleChange("date", d)}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="input">
                  <label>Time</label>
                  <TimeInput
                    value={formData.time}
                    onChange={(val) => handleChange("time", val)}
                  />
                </div>
              </>
            )}

            {trip === "roundtrip" && (
              <>
                <div className="input">
                  <label>From</label>
                  <input
                    type="text"
                    placeholder="Enter pickup location"
                    value={formData.from}
                    onChange={(e) => handleChange("from", e.target.value)}
                  />
                </div>

                <div className="input">
                  <label>To</label>
                  <input
                    type="text"
                    placeholder="Enter destination"
                    value={formData.to}
                    onChange={(e) => handleChange("to", e.target.value)}
                  />
                </div>

                <div className="input">
                  <label>Date</label>
                  <DatePicker
                    selected={formData.date}
                    onChange={(d) => handleChange("date", d)}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="input">
                  <label>Pickup Time</label>
                  <TimeInput
                    value={formData.time}
                    onChange={(val) => handleChange("time", val)}
                  />
                </div>

                <div className="input return-field">
                  <label>Return Time</label>
                  <TimeInput value={time} onChange={setTime} />
                </div>
              </>
            )}

            {trip === "airport" && (
              <div className="airport-wrapper">
                <div className="airport-options">
                  <label>
                    <input
                      type="radio"
                      name="airportType"
                      checked={airportType === "pickup"}
                      onChange={() => setAirportType("pickup")}
                    />
                    Pickup from Airport
                  </label>

                  <label>
                    <input
                      type="radio"
                      name="airportType"
                      checked={airportType === "drop"}
                      onChange={() => setAirportType("drop")}
                    />
                    Drop to Airport
                  </label>
                </div>

                <div className="form-grid">
                  {airportType === "pickup" && (
                    <>
                      <div className="input airport-input-div">
                        <label>Pickup Airport</label>
                        <input
                          type="text"
                          placeholder="Enter airport name"
                          value={formData.airport}
                          onChange={(e) =>
                            handleChange("airport", e.target.value)
                          }
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Drop Address</label>
                        <input
                          type="text"
                          placeholder="Enter drop address"
                          value={formData.address}
                          onChange={(e) =>
                            handleChange("address", e.target.value)
                          }
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Date</label>
                        <DatePicker
                          selected={formData.date}
                          onChange={(d) => handleChange("date", d)}
                          dateFormat="dd/MM/yyyy"
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Time</label>
                        <TimeInput
                          value={formData.time}
                          onChange={(val) => handleChange("time", val)}
                        />
                      </div>
                    </>
                  )}

                  {airportType === "drop" && (
                    <>
                      <div className="input airport-input-div">
                        <label>Pickup Address</label>
                        <input
                          type="text"
                          placeholder="Enter pickup location"
                          value={formData.from}
                          onChange={(e) => handleChange("from", e.target.value)}
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Drop Airport</label>
                        <input
                          type="text"
                          placeholder="Enter airport name"
                          value={formData.airport}
                          onChange={(e) =>
                            handleChange("airport", e.target.value)
                          }
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Date</label>
                        <DatePicker
                          selected={formData.date}
                          onChange={(d) => handleChange("date", d)}
                          dateFormat="dd/MM/yyyy"
                        />
                      </div>

                      <div className="input airport-input-div">
                        <label>Time</label>
                        <TimeInput
                          value={formData.time}
                          onChange={(val) => handleChange("time", val)}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}

            {trip === "local" && (
              <>
                <div className="input">
                  <label>Date</label>
                  <DatePicker
                    selected={formData.date}
                    onChange={(d) => handleChange("date", d)}
                    dateFormat="dd/MM/yyyy"
                  />
                </div>

                <div className="input">
                  <label>Pickup Time</label>
                  <TimeInput value={time} onChange={setTime} />
                </div>
              </>
            )}
          </div>
        </>
      )}

      {/* ================= CAR RENTAL ================= */}

      {vehicle === "car" && tab === "rental" && (
        <div className="car-rental-section">
          <div className="rental-options">
            <button
              className={
                rentalType === "driver" ? "rental-btn active" : "rental-btn"
              }
              onClick={() => setRentalType("driver")}
            >
              With Driver
            </button>

            <button
              className={
                rentalType === "self" ? "rental-btn active" : "rental-btn"
              }
              onClick={() => setRentalType("self")}
            >
              Self Drive
            </button>

            <button
              className={
                rentalType === "wedding" ? "rental-btn active" : "rental-btn"
              }
              onClick={() => setRentalType("wedding")}
            >
              Wedding / Vintage
            </button>
          </div>

          <div className="form-grid">
            <div className="input">
              <label>From</label>
              <input
                type="text"
                placeholder="Enter pickup location"
                value={formData.from}
                onChange={(e) => handleChange("from", e.target.value)}
              />
            </div>

            <div className="input">
              <label>To</label>
              <input
                type="text"
                placeholder="Enter drop address"
                value={formData.address}
                onChange={(e) => handleChange("address", e.target.value)}
              />
            </div>

            <div className="input">
              <label>Date</label>
              <DatePicker
                selected={formData.date}
                onChange={(d) => handleChange("date", d)}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div className="input">
              <label>Time</label>
              <TimeInput
                value={formData.time}
                onChange={(val) => handleChange("time", val)}
              />
            </div>
          </div>
        </div>
      )}
      {/* ================= BIKE BOOKING ================= */}

      {vehicle === "bike" && tab === "booking" && (
        <div className="form-grid">
          <div className="input">
            <label>Bike Pickup</label>
            <input
              type="text"
              placeholder="Enter pickup location"
              value={formData.from}
              onChange={(e) => handleChange("from", e.target.value)}
            />
          </div>
          <div className="input">
            <label>Destination</label>
            <input
              type="text"
              placeholder="Enter destination"
              value={formData.to}
              onChange={(e) => handleChange("to", e.target.value)}
            />
          </div>
          <div className="input">
            <label>Date</label>
            <DatePicker
              selected={formData.date}
              onChange={(d) => handleChange("date", d)}
              dateFormat="dd/MM/yyyy"
            />
          </div>
          <div className="input">
            <label>Time</label>
            <TimeInput
              value={formData.time}
              onChange={(val) => handleChange("time", val)}
            />
          </div>
        </div>
      )}

      {/* ================= BIKE RENTAL ================= */}

      {vehicle === "bike" && tab === "rental" && (
        <div className="rental-box">
          <div className="input">
            <label>From</label>
            <input
              type="text"
              placeholder="Enter pickup location"
              value={formData.from}
              onChange={(e) => handleChange("from", e.target.value)}
            />
          </div>
          <div className="input">
            <label>To</label>
            <input
              type="text"
              placeholder="Enter drop address"
              value={formData.address}
              onChange={(e) => handleChange("address", e.target.value)}
            />
          </div>
          <div className="input">
            <label>Date</label>
            <DatePicker
              selected={formData.date}
              onChange={(d) => handleChange("date", d)}
              dateFormat="dd/MM/yyyy"
            />
          </div>
          <div className="input">
            <label>Time</label>
            <TimeInput
              value={formData.time}
              onChange={(val) => handleChange("time", val)}
            />
          </div>
        </div>
      )}

      {/* ================= BICYCLE RENTAL ================= */}

      {vehicle === "bicycle" && tab === "rental" && (
        <div className="rental-box">
          <div className="input">
            <label> From</label>
            <input
              type="text"
              placeholder="Enter pickup location"
              value={formData.from}
              onChange={(e) => handleChange("from", e.target.value)}
            />
          </div>
          <div className="input">
            <label>To</label>
            <input
              type="text"
              placeholder="Enter drop address"
              value={formData.address}
              onChange={(e) => handleChange("address", e.target.value)}
            />
          </div>
          <div className="input">
            <label>Date</label>
            <DatePicker
              selected={formData.date}
              onChange={(d) => handleChange("date", d)}
              dateFormat="dd/MM/yyyy"
            />
          </div>
          <div className="input">
            <label>Pickup Time</label>
            <TimeInput
              value={formData.time}
              onChange={(val) => handleChange("time", val)}
            />
          </div>
        </div>
      )}

      <div className="book-btn-wrapper">
        <button className="book-now-btn" onClick={handleBooking}>
          Book Now
        </button>
      </div>
    </div>
  );
};

export default HeroDataSection;
